<template>
    <card-skeleton v-if="hasBookings" :is-loading="isLoading">
        <v-card-item>
            <card-title :text="t('yourBookings.yourBookingsTitle')">
                <card-button class="pa-2" size="large" :link="link">
                    {{ t('yourBookings.yourBookingsButton') }}
                </card-button>
            </card-title>
        </v-card-item>
        <v-card-text>
            <booking-card-list :bookings="bookings" :disabled="isLoading" @click:cancel-booking="handleCancelBooking" />
        </v-card-text>
    </card-skeleton>
</template>

<script setup lang="ts">
import { onMounted, ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import CardSkeleton from '@/features/common/components/CardSkeleton.vue';
import CardButton from '@/features/common/components/CardButton.vue';
import CardTitle from '@/features/common/components/CardTitle.vue';
import BookingCardList from '../components/card/BookingCardList.vue';
import { BookingDto } from '../types';
import { getBookings, cancelBooking } from '../services/api';
import { useAppConfiguration } from '@/composables';
import { generateUrl } from '@/helpers/UrlGenerator';

interface IBookingsListCard {}

defineProps<IBookingsListCard>();

const { t } = useI18n();

const bookings = ref<BookingDto[]>([]);
const isLoading = ref(true);

const { config, language } = useAppConfiguration();
const link = generateUrl(config.value.travelPlannerWebsiteBaseUrl, language.value);

const hasBookings = computed(() => bookings.value.length > 0 || isLoading.value);

async function handleCancelBooking(bookingId: string) {
    isLoading.value = true;

    // cancel booking
    await cancelBooking(bookingId);
    // update bookings
    bookings.value = (await getBookings())?.data || [];

    isLoading.value = false;
}

onMounted(async () => {
    bookings.value = (await getBookings())?.data || [];
    isLoading.value = false;
});
</script>
